/// <amd-module name="Wit/WorkItemDataManager/Utils" />
import { IUnparsedWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";

export function canDeserializeRules(workItemTypeData: IUnparsedWorkItemTypeData): boolean {
    const fieldRules = workItemTypeData?.rules?.fieldRules;
    return typeof fieldRules === "string" || (fieldRules as unknown) instanceof String;
}
